import { EditSalesFunnelPageHeader } from '@pages/SalesFunnels/EditSalesFunnel/components';
import { EditSalesFunnel } from '@pages/SalesFunnels/EditSalesFunnel/EditSalesFunnel.main';

export { EditSalesFunnel, EditSalesFunnelPageHeader };
